import { Dialog } from '@material-ui/core';
import { FC } from 'react';
import { TFunction } from 'react-i18next';

import { ModalInfoIcon } from 'assets/icons';
import { DSButton } from '../../../../designSystem';
import DialogCard from '../../../../shared/components/dialog/dialogCard';
import './styles.scss';

interface Props {
	t: TFunction<'translation'>;
	onClose: () => void;
	onAcceptConsents: () => void;
}

const SelectConsentDialog: FC<Props> = ({ t, onClose, onAcceptConsents }) => {
	return (
		<Dialog
			maxWidth={'xs'}
			fullWidth
			onClose={onClose}
			className="custom-dialog bg--transparent custom--box-shadow text--center dialog-wrapper"
			aria-labelledby="customized-dialog"
			open={true}
		>
			<DialogCard
				title={t('selectConsentsInfo')}
				titleClass={'text-h3 text-gray-900 dark:text-gray-100'}
				subTitleClass={'text-paragraph-md text-gray-700 dark:text-gray-200'}
				subTitle={t('selectConsentsDescription')}
				className="warning--card consent-dialog "
				icon={ModalInfoIcon}
				cardBottomText="Przejdź do weryfikacji"
				cardBottomCustom={
					<div className="inactive-user-dialog-buttons">
						<DSButton size="medium" color="primary" onClick={onAcceptConsents}>
							{t('tickConsent')}
						</DSButton>
						<DSButton size="medium" color="tertiary" onClick={onClose}>
							{t('nextTime')}
						</DSButton>
					</div>
				}
			/>
		</Dialog>
	);
};

export default SelectConsentDialog;
